@if (products$ | async) {}
@if (userInfo$ | async) {}
@if (action$ | async) {}

@if (isVisible) {
  <nz-layout class="app-layout">
    <nz-sider
      nzCollapsible
      [nzCollapsed]="isCollapsed"
      [nzTrigger]="null"
      class="menu-sidebar"
      nzTheme="light"
      nzWidth="200px"
    >
      <div class="sidebar-logo">
        <svg
          class="style-logo"
          [style.width]="75"
          [style.height]="75"
          version="1.1"
          id="svg2"
          xml:space="preserve"
          viewBox="150 100 1250 1250"
          sodipodi:docname="BFS_logypes_RGB.eps"
          xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
          xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:svg="http://www.w3.org/2000/svg"
        >
          <defs id="defs6" />

          <g
            id="g8"
            inkscape:groupmode="layer"
            inkscape:label="ink_ext_XXXXXX"
            transform="matrix(1.3333333,0,0,-1.3333333,0,4136)"
          >
            <g id="g10" transform="scale(0.1)">
              <path
                d="m 2666.13,24623.7 h 1497.09 c 81.24,0 127.68,23.2 177.97,73.5 l 379.1,379.1 c 50.28,50.2 77.4,100.5 77.4,181.8 v 116 c 0,81.3 -19.32,123.9 -77.4,181.8 l -301.7,301.7 301.7,301.7 c 54.13,54.2 77.4,96.8 77.4,154.7 v 154.7 c 0,65.8 -15.48,104.4 -77.4,170.2 l -359.78,363.6 c -54.13,58.1 -100.57,73.5 -181.81,73.5 H 2662.29 Z m 386.9,363.6 v 692.5 h 1249.51 c 69.61,0 104.41,-38.7 104.41,-104.4 v -483.7 c 0,-69.6 -30.96,-104.4 -104.41,-104.4 z m 0,1056.2 v 669.3 h 1249.51 c 61.92,0 104.41,-38.7 104.41,-104.4 V 26148 c 0,-65.7 -38.64,-104.4 -104.41,-104.4 H 3053.03 Z m 2061.95,-1419.8 h 390.74 v 951.7 c 0,77.4 38.65,104.4 96.73,104.4 h 1439.12 v 363.6 H 5799.74 c -88.93,0 -123.84,-23.2 -177.97,-77.4 l -116.05,-116.1 v 862.8 h 1620.93 v 363.6 H 5114.98 Z m 2843.33,0 h 854.92 c 81.25,0 123.85,15.5 181.82,73.5 l 379.1,379.1 c 54.12,54.1 73.45,92.8 73.45,174.1 v 170.2 c 0,77.4 -19.33,112.2 -73.45,166.3 l -456.51,456.5 H 7819.09 c -73.45,0 -108.36,34.8 -108.36,104.4 v 460.4 c 0,65.7 34.8,104.4 108.36,104.4 h 1133.47 c 65.76,0 104.41,-34.8 104.41,-104.4 v -375.3 h 390.74 v 208.9 c 0,81.3 -15.48,123.9 -73.45,181.8 l -379.1,379.1 c -61.93,62 -100.57,73.5 -181.82,73.5 h -854.92 c -92.89,0 -135.37,-27.1 -181.82,-73.5 l -379.1,-379.1 c -58.08,-58 -77.4,-100.5 -77.4,-174.1 v -135.4 c 0,-81.2 15.48,-119.8 77.4,-181.8 l 452.66,-452.6 h 1102.51 c 73.45,0 104.41,-27.1 104.41,-104.4 v -483.7 c 0,-69.6 -30.96,-104.4 -104.41,-104.4 H 7819.09 c -73.45,0 -108.36,34.8 -108.36,104.4 v 375.3 h -390.74 v -208.7 c 0,-77.4 19.32,-123.9 77.4,-181.8 l 379.1,-379.1 c 58.08,-58.1 100.57,-73.6 181.82,-73.6 z m 1504.88,2448.9 h 58.08 v 201.1 h 85.08 v 54.1 H 9378.1 v -54.1 h 85.09 z m 189.6,0 h 58.08 v 201.1 h 15.48 l 54.13,-201.1 h 54.13 l 54.12,201.1 h 15.48 v -201.1 h 58.08 v 255.3 h -108.36 l -46.44,-181.8 -46.44,181.8 h -108.37 v -255.3 h 0.11"
                style="
                  fill: #000a19;
                  fill-opacity: 1;
                  fill-rule: nonzero;
                  stroke: none;
                "
                id="path24"
              />
            </g>
          </g>
        </svg>

        <a [routerLink]="['/']">
          <span>{{ isCollapsed ? "" : "Сервис управления релизами" }}</span>
        </a>
      </div>
      <ul nz-menu nzMode="inline">
        @for (route of routes; track $index) {
          <li
            nz-menu-item
            nzMatchRouter
            nz-popover
            [nzPopoverTrigger]="isCollapsed ? 'hover' : null"
            nzPopoverPlacement="right"
            [nzPopoverContent]="route.title"
          >
            <a
              nz-tooltip
              class="unhealthy"
              nzTooltipPlacement="right"
              [routerLink]="[route.path]"
            >
              <span>{{ route.title }}</span>
            </a>
          </li>
        }
      </ul>

      <nz-divider class="sidebar-divider"></nz-divider>
      <div
        nz-popover
        class="avatar"
        nzPopoverPlacement="rightBottom"
        nzPopoverTrigger="hover"
        nzPopoverOverlayClassName="user-profile-popover"
        [nzPopoverTitle]="userFullName"
        [nzPopoverContent]="contentTemplate"
        [class.collapsed]="isCollapsed"
      >
        <nz-avatar [nzText]="userProfile?.firstName?.at(0)"></nz-avatar>
        @if (!isCollapsed) {
          <span>{{ userProfile?.firstName }} {{ userProfile?.lastName }} </span>
        }
      </div>
      <ng-template #contentTemplate>
        <nz-list class="profile-list">
          <nz-list-item class="logout" (click)="onLogoutUserEvent()">
            Выйти
            <i nz-icon nzType="logout"></i>
          </nz-list-item>
        </nz-list>
      </ng-template>
    </nz-sider>
    <nz-layout class="app-header">
      <nz-header>
        <div class="customer-header">
          <h4 class="customer-name">{{ customerName }}</h4>
          <div class="actions-wrapper">
            <div>
              Уведомления <br />
              о новых релизах
            </div>
            <nz-switch
              [(ngModel)]="isSendEmailNotifications"
              (ngModelChange)="changeSendEmailNotification($event)"
            />
          </div>
        </div>
        <nz-divider class="divider"></nz-divider>
        <div class="trigger" (click)="onCollapseEvent()">
          @if (!isCollapsed) {
            <i class="trigger-icon" nz-icon nzType="left" nzTheme="outline"></i>
          } @else {
            <i
              class="trigger-icon"
              nz-icon
              nzType="right"
              nzTheme="outline"
            ></i>
          }
        </div>
      </nz-header>
      <nz-content class="app-content">
        <router-outlet></router-outlet>
      </nz-content>
    </nz-layout>
  </nz-layout>
}

@if (!isVisible) {
  <router-outlet></router-outlet>
}
